import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.aufgabe-fehler-bild-scaled';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeFehlerBildScaledEffects {

    AufgabeFehlerBildScaled$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_AUFGABE_FEHLER_BILD_SCALED),
        mergeMap((x: ac.GetAufgabeFehlerBildScaledAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAufgabeFehlerBildScaled(x.aufgabe_id, x.bild_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetAufgabeFehlerBildScaledErfolgreichAction(result, x.aufgabe_id, x.bild_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAufgabeFehlerBildScaledFehlerAction(error, x.aufgabe_id, x.bild_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenQueryService);
        }
        return this.service;
    }
}
